module.exports = __webpack_public_path__ + "img/work-classify.eb39aaf5.png";